module.exports = __webpack_public_path__ + "assets/35653c0468b9c08bc8965da27077fa84.mp3";